import { Config } from '../../config'

export const andwinConfig: Config = {
  partner: 'andwin',
  catalog: 'partner',
  displayName: 'Andwin Scientific',
  accentColor: '#156fb4',
  host: 'chairs.andwinsci.com',
}
